import React, {useState} from "react";

import {useNavigate, useParams} from "react-router-dom";
import Integrations from "../components/Integrations";

const IntegrationsPage = () => {
    const navigate = useNavigate();
    const firstName = localStorage.getItem("firstName");

    const handleLogout = (event) => {
        event.preventDefault(); // Prevent default link/button behavior if necessary
        console.log("Navigating to /login...");
        // Clear session storage
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("universityId");
        console.log("Logging out...");
        // Redirect to login page
        navigate("/login");
    };
  return (
        <div className="dashboard">
            <aside className="sidebar">
                <h2 className="logo"><img height="60" align="center" src="/libraries/assets/images/new_logo.png"/></h2>
                <nav className="nav">
                    <ul>
                        <li>
                            <a href="/dashboard"><i className="fas fa-home"></i> &nbsp; Dashboard</a>
                        </li>
                        <li>
                            <hr/>
                        </li>
                        <li><a href="/tours">
                            <i className="fas fa-map"></i> &nbsp; Tours</a>
                        </li>
                        <li><a href="/forms">
                            <i className="fas fa-file-alt"></i> &nbsp;&nbsp;&nbsp; Forms</a>
                        </li>
                        <li><a href="/templates">
                            <i className="fas fa-inbox"></i> &nbsp;&nbsp;&nbsp; Email Templates</a>
                        </li>
                        <li><a href="/analytics">
                            <i className="fas fa-chart-bar"></i> &nbsp;&nbsp;&nbsp; Analytics</a>
                        </li>

                        <li>
                            <hr/>
                        </li>
                        <li><a className="active" href="/integrations">
                            <i className="fas fa-random"></i> &nbsp;&nbsp;&nbsp; Integrations</a>
                        </li>
                        <li><a href="#">
                            <i className="fas fa-cog"></i> Settings</a>
                        </li>
                    </ul>
                </nav>
                <div className="profile">

                    <a href="#"
                       onClick={handleLogout}>Logout</a>
                </div>
                <div className="profile">
                    <div className="profile-icon">{firstName.charAt(0)}</div>
                    <span>{firstName}</span>
                </div>
            </aside>

            <main className="main-content">
                <header className="header component">
                    <span className="component-header">Integrations</span>

                </header>
                <p><a href="/dashboard"> Home </a> > Integrations </p>
                <hr/>


                <Integrations/>

            </main>

        </div>

  )
      ;
};

export default IntegrationsPage;